import { useTheme } from '@mui/material/styles';
import info from 'assets/icons/info.svg';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStoreSelector } from 'v3/data/store';
import { GO_BACK } from 'v3/routes/enum';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import {
  ColumnStep,
  Content,
  Icon,
  IconStyled,
  InfoBox,
  RowStep,
  StepNumber,
  StyledDialog,
  TextOpacity,
} from 'v3/shared/components/Modal/ContractingNextStepsModal/styles';
import { IContractingNextStepsModalProps } from 'v3/shared/components/Modal/ContractingNextStepsModal/types';
import { StyledButtonContainer } from 'v3/shared/components/Modal/SellerDataModal/styles';
import { VoucherStatusEnum } from 'v3/shared/enums/voucher-status.enum';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { TitleSmall } from 'v3/shared/typography/TitleSmall';

export const ContractingNextStepsModal: React.FC<IContractingNextStepsModalProps> = ({
  open,
  signContractError,
  onClose,
  onConfirm,
}) => {
  const voucher = useStoreSelector((store) => store.voucher);
  const [isNotInvoiced, setisNotInvoiced] = useState<boolean | undefined>(false);

  const navigate = useNavigate();
  const theme = useTheme();

  const handleOnConfirm = useCallback(async () => {
    const isNotInvoiced = voucher.status === VoucherStatusEnum.Pending;

    setisNotInvoiced(isNotInvoiced);
  }, [voucher.status]);

  useEffect(() => {
    handleOnConfirm();
  }, [handleOnConfirm]);

  return (
    <StyledDialog open={open}>
      <Content>
        <HeadlineSmall color={theme.palette.common.white} align="center">
          Próximos passos para finalizar a contratação
        </HeadlineSmall>
        <Icon src={info} alt="Alert" />
        <ColumnStep>
          <RowStep>
            <StepNumber>1</StepNumber>
            <SubtitleLarge color={theme.palette.common.white} align="left">
              Fature a compra no sistema do Datasys
            </SubtitleLarge>
          </RowStep>
          <RowStep>
            <StepNumber>2</StepNumber>
            <SubtitleLarge color={theme.palette.common.white} align="left">
              Veja se as informações (NF, IMEI, EAN) estão corretas
            </SubtitleLarge>
          </RowStep>
          <InfoBox>
            <IconStyled customColor={theme.palette.common.white} />
            <TitleSmall color={theme.palette.common.white}>
              Atenção: Caso precise modificar as informações (NF.IMEI,EAN) posteriormente não será possível e deverá
              contatar o suporte.
            </TitleSmall>
          </InfoBox>
          <RowStep>
            <StepNumber>3</StepNumber>
            <SubtitleLarge color={theme.palette.common.white} align="left">
              Volte ao Backoffice e veja a contratação finalizada
            </SubtitleLarge>
          </RowStep>
        </ColumnStep>
        <TextOpacity>*Ao finalizar o faturamento no Datasys a página irá atualizar e alterar o status</TextOpacity>

        {signContractError ? (
          <InfoBox>
            <IconStyled customColor={theme.palette.error.light} />
            <TitleSmall color={theme.palette.error.light}>
              Houve um problema para finalizar a sua contratação, por favor tente novamente clicando em ”Já faturei”.
            </TitleSmall>
          </InfoBox>
        ) : null}

        {isNotInvoiced ? (
          <InfoBox>
            <IconStyled customColor={theme.palette.orange.light} />
            <TitleSmall color={theme.palette.orange.light}>
              Aguarde o status mudar, ainda não foi identificado o faturamento no Datasys
            </TitleSmall>
          </InfoBox>
        ) : null}
      </Content>

      <StyledButtonContainer>
        <TextButton
          data-testid="text-button-cancel"
          size="small"
          $outline
          text={'Ver outras contratações'}
          handleClick={() => navigate(GO_BACK)}
        />
        <FlexButton
          data-testis="flex-button-confirm-button-text"
          size="small"
          text={'Já faturei'}
          handleClick={onConfirm}
        />
      </StyledButtonContainer>
    </StyledDialog>
  );
};
